/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import styles from './styles.module.scss';
import { Rating } from '@/components/Rating/Rating';
import { Text } from '@az/starc-ui';
import { roundValueToPrecision } from '@/components/Rating/utils';
import { type ReviewStatistic } from '../../interface/types';
import { formatNumber } from '../../utils/formatNumber';

type ReviewStatsProps = {
  reviewStatistic: ReviewStatistic;
};

export function ReviewStats({ reviewStatistic }: ReviewStatsProps) {
  const averageRating = reviewStatistic.averageOverallRating || '0';
  const hideRating = Math.round(Number(averageRating)) === 0;
  const reviewCount = Number(reviewStatistic.totalReviewCount || '0');
  const roundedRating = roundValueToPrecision(Number(averageRating), 0.1);
  const formattedRating = roundedRating.toFixed(1);

  return (
    <div
      className={styles.reviewsWrapper}
      style={{ visibility: hideRating ? 'hidden' : 'visible' }}
      data-testid="review-stats"
    >
      <Rating
        value={roundedRating}
        showStarFractions={true}
        classes={{ icon: styles.ratingStar }}
      />
      <Text variant="small-body" className={styles.ratingText}>
        {formattedRating}
      </Text>
      <Text
        variant="text-link"
        decoration="underline"
        color="gray-600"
        className={styles.ratingText}
      >
        ({formatNumber(reviewCount)})
      </Text>
    </div>
  );
}
